import React from 'react';

/**
 * Minimalist analytics tile — matches the dashboard stat cards.
 * Single blue accent (BookingFlows blue), neutral values. Reusable.
 *
 * tone: 'default' | 'primary' | 'warn'  (controls value color only)
 */
const TONE = {
  default: 'text-gray-900',
  primary: 'text-blue-600',
  warn: 'text-amber-600',
};

export const MetricTile = ({ label, value, icon: Icon, hint, tone = 'default', testid }) => (
  <div className="card-soft p-4 sm:p-5" data-testid={testid}>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center shrink-0">
        {Icon ? <Icon className="w-4 h-4 text-blue-600" /> : null}
      </div>
      <p className="stat-label">{label}</p>
    </div>
    <p className={`stat-value ${TONE[tone] || TONE.default} truncate`}>{value}</p>
    {hint ? <p className="stat-caption mt-2 hidden sm:block">{hint}</p> : null}
  </div>
);

export default MetricTile;
